import { action } from 'typesafe-actions'
import { HyperLinkMenu } from '@models/hyperLinkMenu'
import {RequestData} from "@models/axios";

export const enum HyperLinkMenusActionTypes {
    FETCH_REQUEST = '@@hyperLinkMenus/FETCH_REQUEST',
    FETCH_SUCCESS = '@@hyperLinkMenus/FETCH_SUCCESS',
    FETCH_ERROR = '@@hyperLinkMenus/FETCH_ERROR',

    DELETE_REQUEST = '@@hyperLinkMenus/DELETE_REQUEST',
    DELETE_SUCCESS = '@@hyperLinkMenus/DELETE_SUCCESS',
    DELETE_ERROR = '@@hyperLinkMenus/DELETE_ERROR',

    CREATE_REQUEST = '@@hyperLinkMenus/CREATE_REQUEST',
    CREATE_SUCCESS = '@@hyperLinkMenus/CREATE_SUCCESS',
    CREATE_ERROR = '@@hyperLinkMenus/CREATE_ERROR',

    UPDATE_REQUEST = '@@hyperLinkMenus/UPDATE_REQUEST',
    UPDATE_SUCCESS = '@@hyperLinkMenus/UPDATE_SUCCESS',
    UPDATE_ERROR = '@@hyperLinkMenus/UPDATE_ERROR',
}



export const fetchRequest = (data:RequestData) => action(HyperLinkMenusActionTypes.FETCH_REQUEST, data);
export const fetchSuccess = (data: HyperLinkMenu[]) => action(HyperLinkMenusActionTypes.FETCH_SUCCESS, data);
export const fetchError = (message: string) => action(HyperLinkMenusActionTypes.FETCH_ERROR, message);

export const deleteRequest = (data:RequestData) => action(HyperLinkMenusActionTypes.DELETE_REQUEST, data);
export const deleteSuccess = (data:RequestData) => action(HyperLinkMenusActionTypes.DELETE_SUCCESS, data);
export const deleteError = (message: string) => action(HyperLinkMenusActionTypes.DELETE_ERROR, message);

export const createRequest = (data:RequestData) => action(HyperLinkMenusActionTypes.CREATE_REQUEST, data);
export const createSuccess = (data: HyperLinkMenu[]) => action(HyperLinkMenusActionTypes.CREATE_SUCCESS, data);
export const createError = (message: string) => action(HyperLinkMenusActionTypes.CREATE_ERROR, message);

export const updateRequest = (data:RequestData) => action(HyperLinkMenusActionTypes.UPDATE_REQUEST, data);
export const updateSuccess = (data: HyperLinkMenu[]) => action(HyperLinkMenusActionTypes.UPDATE_SUCCESS, data);
export const updateError = (message: string) => action(HyperLinkMenusActionTypes.UPDATE_ERROR, message);
